// Notes internes des extras / credits : la table extra_notes du service
// generique (voir notesService.js). Garde l'ancienne entree pour ses appelants.
import { extraNotesService } from './notesService';

export { NOTE_MAX_LENGTH } from './notesService';

export const { list, listSummaryByProject, create, update, remove, getCurrentUserId } = extraNotesService;

export default extraNotesService;
